import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from "@apollo/client";
import possibleTypes from "../types/possibleTypes";

const API_URL = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000";

export default function makeApolloClient(initialState: NormalizedCacheObject = {}) {
  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    cache: new InMemoryCache({
      possibleTypes: possibleTypes.possibleTypes
    }).restore(initialState),
    link: new HttpLink({
      uri: API_URL
    })
  });
}
